import React from 'react';
import { Popconfirm, message } from 'antd';
import TableC from '../../../basicElement/TableC';
import API_URL from '../../../../common/url';
import ExportUtil from '../../../../common/ExportUtil';

const download = (vitaeId) => {
    ExportUtil.export({ vitaeId, typeName: 'DOCX' }, null, API_URL.personal.downloadVitaeByType);
    message.success('正在下载中!')
};

function AssignedUser({ data, isPrev, editable, showEmployeeDetail, releaseContribute }) {
    const getColumns = () => {
        const [{ detailList = [] } = {}] = data || [];
        const columns = [{
            title: isPrev ? '被分配人员' : '已分配人员',
            dataIndex: 'userName',
            key: 'userName',
            fixed: 'left',
            width: 100,
            render: (text, record) => <a onClick={() => showEmployeeDetail(record.userId, record.employeeCode, text)}>{text}</a>,
        }];
        if (!editable) {
            columns.push({
                title: '个人简历',
                dataIndex: 'vitaeName',
                key: 'vitaeName',
                fixed: 'left',
                width: 160,
                render: (text, record) => {
                    const { vitaeId } = record
                    return <a onClick={() => download(vitaeId)}>{text}</a>
                }
            });
        }
        columns.push({
            title: '人员到位时间',
            dataIndex: 'employeeArrivalTime',
            key: 'employeeArrivalTime',
            fixed: 'left',
            width: 100,
            render: text => text ? text.slice(0, 10) : ''
        });
        
        if (detailList.length) {
            const children = detailList.map(i => {
                const date = `${i.year}.${i.month}`;
                return {
                    title: date,
                    dataIndex: date,
                    key: date,
                    width: 80,
                }
            });

            columns.push({
                title:  isPrev ? '预分配FTE' : '已分配FTE',
                children,
            });
        }

        if (editable) {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                fixed: 'right',
                width: 100,
                render: (text, record) => {
                    if (record.canRelease) {
                        return (
                            <Popconfirm title='确定要将该CRC人员解除分配?' onConfirm={() => releaseContribute(record)} okText="确定" cancelText="取消">
                                <a>解除分配</a>
                            </Popconfirm>
                        )
                    } else {
                        return <a disabled>解除分配</a>
                    }
                }
            });
        }

        return columns;
    }

    const getDataSource = () => {
        return (data || []).map(item => {
            const {
                assignmentId, userId, userName, employeeCode,
                canRelease, employeeArrivalTime, detailList, vitaeId, vitaeName,
            } = item;
            const params = {
                assignmentId,
                userId,
                userName,
                employeeCode,
                canRelease,
                vitaeId,
                vitaeName,
                employeeArrivalTime,
            };

            (detailList || []).forEach(i => {
                params[`${i.year}.${i.month}`] = i.showFte ? i.showFte.toFixed(2) : 0;
            });

            return params;
        });
    }

    return (
        <TableC
            columns={getColumns()}
            data={getDataSource()}
            className="assignedUser"
            rowKey="userId"
        />
    );
}

export default AssignedUser;


// WEBPACK FOOTER //
// ./src/components/user/require/tables/AssignedUser.js